import type { ChatRequest, ChatResponse, LlmProvider } from '@rally/llm';

/**
 * An LLM provider for the browser: forwards chat requests to the Rally
 * server's /api/llm proxy so model keys never reach the page.
 */
export class ProxyProvider implements LlmProvider {
  readonly name: string;
  readonly model: string;
  constructor(
    readonly url: string,
    label: string,
  ) {
    const [name, ...model] = label.split(':');
    this.name = name ?? 'proxy';
    this.model = model.join(':') || 'default';
  }
  async chat(req: ChatRequest): Promise<ChatResponse> {
    const res = await fetch(this.url, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ messages: req.messages, tools: req.tools }) });
    const body = (await res.json()) as { text?: string; toolCalls?: ChatResponse['toolCalls']; error?: string };
    if (!res.ok) throw Object.assign(new Error(body.error ?? `LLM proxy ${res.status}`), { name: 'LlmError', status: res.status });
    return { text: body.text ?? '', toolCalls: body.toolCalls ?? [] } as ChatResponse;
  }
}
